import { Link as RouterLink } from 'react-router-dom';
import { Theme, makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    padding: theme.spacing(2),
  },
  separator: {
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },
}));

export function Footer() {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <footer className={classes.footer}>
      <Typography variant="body2" color="textSecondary" align="center">
        Copyright © {new Date().getFullYear()}. All Rights Reserved. APRU VSE
      <br />
        Copyright © {new Date().getFullYear()}. All Rights Reserved. The Chinese University of Hong Kong
        <span className={classes.separator}>|</span>
        <Link color='secondary' component={RouterLink} to='/disclaimer'>Disclaimer</Link>
      </Typography>
    </footer>
  );
}
